import type { ColumnFilter } from '@tanstack/react-table';

const createFilterQueryString = (filters: ColumnFilter[]) => {
  const params = new URLSearchParams();

  filters.map(({ id, value }, index) => {
    if (value !== undefined && value !== null) {
      params.append(`filter[${index.toString()}][filterBy]`, id);
      params.append(`filter[${index.toString()}][filterString]`, value as string);
    }
  });

  return params.toString();
};

export { createFilterQueryString };
